module.exports = __webpack_public_path__ + "static/media/qNNl5QGpetE.63eb8e47.png";